module.exports = __webpack_public_path__ + "static/img/avatar_advi@3x.ce3151ce.png";